// frontend/src/components/AuthModal.jsx

import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import './AuthModal.css';

const AuthModal = ({ isOpen, onClose }) => {
    const [mode, setMode] = useState('login');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const { customerLogin } = useAuth();

    const resetFields = () => {
        setName('');
        setEmail('');
        setPassword('');
    };

    const handleTabSwitch = (newMode) => {
        setMode(newMode);
        resetFields();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (mode === 'signup') {
                const res = await api.post('/auth/register', { name, email, password });
                customerLogin(res.data.token, res.data.user);
            } else {
                // FIX: customer login route is /auth/customer-login, NOT /auth/login
                // /auth/login is the ADMIN login route
                const res = await api.post('/auth/customer-login', { email, password });
                customerLogin(res.data.token, res.data.user);
            }
            resetFields();
            onClose();
        } catch (err) {
            toast.error(err.response?.data?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="auth-modal-overlay"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div
                        className="auth-modal"
                        initial={{ y: 50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: 50, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        onClick={e => e.stopPropagation()}
                    >
                        <button
                            className="auth-modal-close"
                            onClick={onClose}
                            aria-label="Close"
                        >
                            ×
                        </button>

                        <div className="auth-tabs">
                            <button
                                className={mode === 'login' ? 'active' : ''}
                                onClick={() => handleTabSwitch('login')}
                            >
                                Login
                            </button>
                            <button
                                className={mode === 'signup' ? 'active' : ''}
                                onClick={() => handleTabSwitch('signup')}
                            >
                                Sign Up
                            </button>
                        </div>

                        <form onSubmit={handleSubmit}>
                            {mode === 'signup' && (
                                <input
                                    type="text"
                                    placeholder="Full Name"
                                    value={name}
                                    onChange={e => setName(e.target.value)}
                                    required
                                    autoComplete="name"
                                />
                            )}
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                                autoComplete="email"
                            />
                            <input
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                                autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
                            />
                            <button type="submit" disabled={loading}>
                                {loading
                                    ? 'Please wait...'
                                    : mode === 'login'
                                        ? 'Login'
                                        : 'Create Account'}
                            </button>
                        </form>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default AuthModal;
